import { useEffect, useRef, useState } from 'react';

// Custom components
import { BackdropLoading } from '../../components/BackdropLoading';

// Styles
import { Container, PageTitle, CustomFormLabel, CustomButtonV2 } from '../styles';
import { FormContainer, SectionPageTitle, Text, ContainerContent, ContainerTitle} from './styles';

// API
import { FormApi } from '../../services/FormApi';

// Router
import { useLocation } from 'react-router-dom'
import Router from '../../router';

// Icons
import { SaveAltRounded } from '@mui/icons-material';

// Utils
import { useTranslation } from 'react-i18next'
import { downloadPDF } from '../../utils/commonFunctions/downloadPdf';
import { FormIo } from '../../components/molecules/forms/FormIo';
import NavigateBackButton from '../../components/atoms/NavigateBackButton';

export const FormManagementDetailV2 = (props) => {
    const { t } = useTranslation();
    const formApi = new FormApi();
    const location = useLocation();
	const [row, setRow] = useState({id: null, name: ''})
	const [form, setForm] = useState({structure: []})
	const [formStructure, setFormStructure] = useState([])
	const formRef = useRef(null);
	const [loading, setLoading] = useState(false)
	const [loadingPdf, setLoadingPdf] = useState(false)

    useEffect(() => {
		let row = location?.state?.row;

		if (row?.id) {
			setRow(row)
	
			async function call() {
				setLoading(true)
				const response = await formApi.detail(row.id);
				if (response.status === 200) {
					setForm(response.data)

					let dataStructure = response.data?.structure?.structure
					setFormStructure({ components: dataStructure })
				}
				setLoading(false)
			}
			call()
		}
    }, [props.isDemo])

	const generatePdf = async() => {
		await downloadPDF(form.structure?.structure, formRef, form.structure?.form?.name || 'form_pdf', setLoadingPdf)
	}

    return (
        <Container open={props.open} mb={6}>
			<SectionPageTitle>
				<NavigateBackButton route={Router.appFormManagementV2} />
				<PageTitle>{t('forms.formManagement.formDetail') + ' ' + row?.id}</PageTitle>
			</SectionPageTitle>
            {!loading &&
                <FormContainer>
                    <ContainerContent>
                        <ContainerTitle>
                            <CustomFormLabel bold>{t('forms.formManagement.formName')}:</CustomFormLabel> <Text>{form.name}</Text>
                        </ContainerTitle>
                        <ContainerTitle>
                            <CustomFormLabel bold>{t('forms.formManagement.workflow')}:</CustomFormLabel><Text>{form.workflow?.name}</Text>
                        </ContainerTitle>
                        <ContainerTitle>
                            <CustomFormLabel bold>{t('forms.formManagement.integrationKey')}:</CustomFormLabel><Text>{form.integrationKey}</Text>
                        </ContainerTitle>
                        <ContainerTitle>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', width: '100%' }}>
								<CustomButtonV2
									onClick={generatePdf}
									btnType="secondary"
									sx={{ width: '150px' }}
									startIcon={<SaveAltRounded/>}
								>
									{t('common.downloadPdf')}
								</CustomButtonV2>
                            </div>
                        </ContainerTitle>
                    </ContainerContent>
                    <div ref={formRef}>
                        <FormIo 
                            form={formStructure.components}
                            data={{}}
                            readOnly={false}
                        />
                    </div>
                </FormContainer>
            }
            <BackdropLoading open={loading}/>
            <BackdropLoading open={loadingPdf}/>
		</Container>
	)
}
